type LoginCredentials = {
	identifier: string
	password: string
}

export const useAuth = <T extends StrapiUser>() => {
	
	const { login: strapiLogin, logout: strapiLogout } = useStrapiAuth()

	const currentUser = useStrapiUser() as Ref<T>
	const role = computed(() => currentUser.value?.role?.type)
	
	async function login(credentials: LoginCredentials) {
		await strapiLogin(credentials)
		useToast().clear()
		await navigateTo('/')
	}
	
	async function logout(): Promise<void> {
		try {
			strapiLogout()
			await navigateTo('/login')
		} catch (error) {
			return console.error(error)
		}
	}
	
	return {
		currentUser,
		role,
		login,
		logout
	}
}
